import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const PUBLIC_ROUTES = ['/dashboard', '/'];
const SYSADMIN_ROUTES = ['/division-master', '/control-parameters', '/logging'];
const OPEN_ROUTES = [];

const RouteGuard = ({ children }) => { // NOSONAR
  const location = useLocation();
  const currentPath = location.pathname || '/';

  if (PUBLIC_ROUTES.includes(currentPath)) {
    return children;
  }

  // Open routes accessible to all authenticated users
  if (OPEN_ROUTES.includes(currentPath)) {
    return children;
  }

  // SYSADMIN-only routes
  if (SYSADMIN_ROUTES.includes(currentPath)) {
    const userData = JSON.parse(sessionStorage.getItem('userData') || '{}');
    const role = userData.roleCode || userData.role || '';
    if (role === 'SYSADMIN') return children;
    return <Navigate to="/dashboard" replace />;
  }

  try {
    const authorizedSessions = JSON.parse(sessionStorage.getItem('AuthorizedSessions') || '{}');
    const authorizedUrls = [];

    for (const parentMenu in authorizedSessions) {
      if (authorizedSessions[parentMenu]) {
        for (const menu of authorizedSessions[parentMenu]) {
          if (menu.menuUrl && menu.read === true) {
            authorizedUrls.push(menu.menuUrl);
          }
        }
      }
    }

    if (authorizedUrls.includes(currentPath)) {
      return children;
    }
  } catch (error) {
    console.error('Error checking route access:', error);
  }

  return <Navigate to="/dashboard" replace />;
};

export default RouteGuard;
